import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  // 顧客のノミネーション集計を取得
  getCustomerNominationStats(customerId) {
    return axiosIns.get(`/waiter/customers/${customerId}/nomination_stats`)
  },

  // 顧客のノミネーションタイムラインを取得
  getNominationTimeline(customerId, { page = 1, perPage = 10 } = {}) {
    return axiosIns.get(`/waiter/customers/${customerId}/nomination_timeline`, {
      params: snakecaseKeys({ page, perPage }),
    })
  },
}
